import { memo } from "react";
import When from "ui/support/When";
import { Collection } from "ui/support/Resource";
import { useChange, useColumns } from "../../support";
import Column from "./Column";
import type { ColumnsProps } from "./types";
import { Column as ColumnName, type Comparison } from "../../repository";

type Props = ColumnsProps & {
    readonly getComparisonColumn: (comparison: Comparison) => Comparison[keyof Comparison];
};

export const ColumnConstraints = {
    Reason: [
        ColumnName.Action,
        ColumnName.DateTime,
        ColumnName.Reason,
        ColumnName.ReasonCode
    ]
};

const Columns = ({ slotProps, row, getComparisonColumn }: Props) => {
    const { withAvailableColumns, getScalarColumns } = useColumns();
    const { getChangedDiffs } = useChange();

    return (
        <Collection
            {...slotProps?.collection}
            collection={Object.entries(getChangedDiffs({ row }))
                .filter(([key]) => (
                    !ColumnConstraints.Reason.includes(key as ColumnName)
                ))}
            renderResource={([key, comparison]) => {
                const [colDef] = withAvailableColumns(getScalarColumns, [key]);

                return (
                    <When
                        key={key}
                        if={Boolean(colDef)}
                        then={() => (
                            <Column
                                {...slotProps?.column}
                                name={colDef.headerName!}
                                value={getComparisonColumn(comparison)}
                            />
                        )}
                    />
                );
            }}
        />
    );
};

export default memo(Columns);
